/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

import { all, takeLatest } from 'redux-saga/effects';
import { ActionTypes } from '../constants';
import API from '../../requests';
import { callAPI } from './callAPI';
import { callAPILogin } from './callAPILogin';

export interface DeviceDetailsType {
  latitude: string;
  longitude: string;
  activationCode: string;
}
export interface DeviceType {
  payload: DeviceDetailsType;
}

export function* activateDevice({ payload }: DeviceType): any {
  yield callAPILogin(payload, ActionTypes.DEVICE_ACTIVATION, API.activateDevice);
}

export function* reactivateDevice({ payload }): any {
  yield callAPI(payload, ActionTypes.REACTIVATE_DEVICE, API.reactivateDevice);
}

export default function* root(): Object {
  yield all([takeLatest(ActionTypes.DEVICE_ACTIVATION_REQUEST, activateDevice)]);
  yield all([takeLatest(ActionTypes.REACTIVATE_DEVICE_REQUEST, reactivateDevice)]);
}

